<template>
  <el-menu
    class="el-menu-demo"
    mode="horizontal"
    background-color="#FFFFFF"
    :ellipsis="false"
  >
    <el-menu-item index="1" style="width: 200px">
      <router-link to="/" class="no-underline">首页</router-link>
    </el-menu-item>

    <el-sub-menu index="2">
      <template #title>
        <span class="lab-title">实验室概况</span>
      </template>
      <el-menu-item index="2-1">
        <router-link to="/about" class="no-underline">实验室简介</router-link>
      </el-menu-item>
      <el-menu-item index="2-2">
        <router-link to="/researchdirections" class="no-underline"
          >研究方向</router-link
        >
      </el-menu-item>
      <el-menu-item index="2-3">
        <router-link to="/labstructure" class="no-underline"
          >实验室架构</router-link
        >
      </el-menu-item>
      <el-menu-item index="2-4">
        <router-link to="/lableadership" class="no-underline"
          >实验室主任</router-link
        >
      </el-menu-item>
      <el-menu-item index="2-5">
        <router-link to="/labCommittee" class="no-underline"
          >学术委员会</router-link
        >
      </el-menu-item>
      <el-menu-item index="2-6">
        <router-link to="/rulesandregulations" class="no-underline"
          >规章制度</router-link
        >
      </el-menu-item>
    </el-sub-menu>
    <el-sub-menu index="3">
      <template #title>
        <span class="lab-title">研究队伍</span>
      </template>
      <el-menu-item index="3-1">
        <router-link to="/reserachstaff" class="no-underline"
          >研究人员</router-link
        >
      </el-menu-item>
      <el-menu-item index="3-2">
        <router-link to="/researchlab" class="no-underline">研究室</router-link>
      </el-menu-item>
    </el-sub-menu>

    <el-sub-menu index="4">
      <template #title>
        <span class="lab-title">科学研究</span>
      </template>
      <el-menu-item index="4-1">
        <router-link to="/Team" class="no-underline">科研项目</router-link>
      </el-menu-item>
      <el-menu-item index="4-2">
        <router-link to="/qklw" class="no-underline">科研成果</router-link>
      </el-menu-item>
    </el-sub-menu>

    <el-sub-menu index="5">
      <template #title>
        <span class="lab-title">示范平台</span>
      </template>
      <el-menu-item index="5-1">
        <a href="http://47.120.1.94" class="no-underline" target="_blank"
          >03专项示范应用平台</a
        >
      </el-menu-item>

      <el-menu-item index="5-2">
        <router-link to="/mmplatform" class="no-underline" target="_blank"
          >认知与元认知示范平台</router-link
        >
      </el-menu-item>

      <el-menu-item index="5-3">
        <a href="http://ygc.lgwcoding.top/" class="no-underline" target="_blank"
          >面向在线学习的学生多模态情感分析系统</a
        >
      </el-menu-item>

      <el-menu-item index="5-4">
        <a href="http://gzq.lgwcoding.top/" class="no-underline" target="_blank"
          >面向在线学习的元认知能力评估系统</a
        >
      </el-menu-item>
      <el-menu-item index="5-5">
        <a href="/classroom/login.html" class="no-underline" target="_blank"
          >学习者课堂行为识别应用系统</a
        >
      </el-menu-item>

      <el-menu-item index="5-6">
        <a href="http://cyy.lgwcoding.top/" class="no-underline" target="_blank"
          >教师情感分析系统</a
        >
      </el-menu-item>

      <el-menu-item index="5-7">
        <a
          href="http://120.27.146.153:8085/#/login"
          class="no-underline"
          target="_blank"
          >基于生成式大模型的人格识别及共情对话系统</a
        >
      </el-menu-item>
    </el-sub-menu>

    <el-sub-menu index="6">
      <template #title>
        <span class="lab-title">人才培养</span>
      </template>
      <el-menu-item index="6-1">
        <router-link to="/mentordirectory" class="no-underline"
          >导师名录</router-link
        >
      </el-menu-item>
      <el-menu-item index="6-2">
        <router-link to="/graduatestudent" class="no-underline"
          >研究生</router-link
        >
      </el-menu-item>
      <el-menu-item index="6-3">
        <router-link to="/enrollmentinformation" class="no-underline"
          >招生信息</router-link
        >
      </el-menu-item>
      <el-menu-item index="6-4">
        <router-link to="/trainingprogram" class="no-underline"
          >培养方案</router-link
        >
      </el-menu-item>
    </el-sub-menu>

    <!-- <el-sub-menu index="7">
      <template #title>
        <span class="lab-title">条件设备</span>
      </template>
      <el-menu-item index="7-1">
        <router-link to="/instrumentandequipmentt" class="no-underline"
          >仪器设备</router-link
        >
      </el-menu-item>
    </el-sub-menu> -->

    <el-sub-menu index="7">
      <template #title>
        <span class="lab-title">开放合作</span>
      </template>
      <!-- <el-menu-item index="8-1">
        <router-link to="/developmentfund" class="no-underline"
          >开发基金</router-link
        >
      </el-menu-item> -->
      <el-menu-item index="7-1">
        <router-link to="/studentlecture" class="no-underline"
          >学术报告</router-link
        >
      </el-menu-item>
      <el-menu-item index="7-2">
        <router-link to="/researchnews1" class="no-underline"
          >科研动态</router-link
        >
      </el-menu-item>
    </el-sub-menu>
  </el-menu>
</template>

<script></script>

<style scoped>
/* 去除链接的下划线 */
.no-underline {
  text-decoration: none; /* 去除下划线 */
  font-size: large;
  color: hsl(207, 100%, 50%);
}

.lab-title {
  font-size: large; /* 根据需要调整大小 */
  font-weight: normal; /* 如果需要加粗，可以添加 */
}

/* 设置页面背景颜色和导航栏一致 */
html,
body {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  background-color: #ffffff; /* 设置背景颜色和导航栏一致 */
}

/* 设置菜单容器宽度为1200px并居中 */
.el-menu-demo {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  background-color: #ffffff;
  box-sizing: border-box;
}

.el-menu-demo > .el-menu-item,
.el-menu-demo > .el-sub-menu {
  flex: 1;
  justify-content: center;
  text-align: center;
}
</style>
